const ModuleType = {
  SELFPACED: 1,
  LIVE: 2,
  MOOC: 3,
  CLASSROOM: 4,
  ARTIFACT: 5,
}

export default ModuleType
